import { Route } from '@angular/router';
import { dynamicCardCanMatchGuard } from './dynamic-card-can-match.guard';
import { resolveDynamicCardViewConfig } from './dynamic-card-config.resolve';
import { dynamicSectionCanMatchGuard } from './dynamic-section-can-match.guard';
import { resolveDynamicSectionViewConfig } from './dynamic-section-config.resolve';

export const DYNAMIC_ROUTES = [
  {
    path: '**',
    canMatch: [dynamicCardCanMatchGuard],
    resolve: {
      config: resolveDynamicCardViewConfig
    },
    loadComponent: () =>
      import('@konnektu/dynamic/card').then((c) => c.DynamicCardComponent)
  },
  {
    path: '**',
    canMatch: [dynamicSectionCanMatchGuard],
    resolve: {
      config: resolveDynamicSectionViewConfig
    },
    loadComponent: () =>
      import('@konnektu/dynamic/section').then((c) => c.DynamicSectionComponent)
  }
] as Route[];
